export default __webpack_public_path__ + "static/media/timer_delay.a0a726a9.svg";